module.exports = __webpack_public_path__ + "img/fi-rr-thumbs-down.fa4e262f.svg";